import { t } from 'i18next';
import React, { useState } from 'react';
import './dateAndTime.css';
import calendarIcon from '../../assets/icons/calendar-watch-icon.svg';
import DateAndTimeFormModal from './DateAndTimeFormModal';
import { havePermission, isoToDate } from '../../helpers/helpers';
import { Spinner } from 'reactstrap';
import { CustomAlert } from '../CustomAlert/CustomAlert';

const SelectDateAndTime = ({
    type,
    date,
    setDate,
    isFetchingDates = false,
    error = false,
    errorMessage = '',
}) => {

    const [showDateAndTime, setShowDateAndTime] = useState(false);

    const isAccess = ['ACCESS', 'ACCESS_VISIT'].some(accessType => accessType === type);

    const canEdit = havePermission(3);

    return (
        <>
            <div
                className='rounded-3 pt-3 pb-3 ps-4 pe-4'
                style={{ background: 'var(--new-orange)' }}
            >
                <div className={`d-flex justify-content-between flex-wrap ${(isFetchingDates || error) ? 'align-items-center' : ''}`}>
                    <div className='d-flex align-items-center gap-2'>
                        <img
                            style={{ width: '63px', height: '63px' }}
                            src={calendarIcon}
                            alt=""
                        />
                        {(!isFetchingDates && !error) && (
                            <div className='d-flex align-items-center gap-2 mt-1'>
                                <div className='d-flex flex-column gap-2'>
                                    <p className={'m-0 select-dateAndHour-date'}>{isoToDate(date.accessDate.split('-').join(''))}</p>
                                    <p className={`m-0 select-dateAndHour-hour ${isAccess ? '' : 'isExit'}`}>{date.accessHour}</p>
                                    <p className={`m-0 select-dateAndHour-type ${isAccess ? '' : 'isExit'}`}>{t('ENTRY')}</p>
                                </div>

                                {!isAccess ?
                                    <>
                                        <hr
                                            style={{ border: 'solid 1px #FFFF' }}
                                            className='m-0 opacity-100 ps-4'
                                        />
                                        <div className={`d-flex flex-column gap-2 ms-3 ${date.accessDate !== date.exitDate ? '' : 'mt-3'}`}>
                                            <p className='m-0 select-dateAndHour-date'>
                                                {date.accessDate !== date.exitDate ? isoToDate(date.exitDate.split('-').join('')) : null}
                                            </p>
                                            <p className='m-0 select-dateAndHour-hour'>{date.exitHour}</p>
                                            <p className='m-0 select-dateAndHour-type'>{t('DEPARTURE')}</p>
                                        </div>
                                    </>
                                    : null
                                }

                            </div>
                        )}
                    </div>

                    {isFetchingDates && (<Spinner color='light' />)}

                    {error && (<CustomAlert color={'danger'} text={errorMessage} />)}

                    {canEdit && (
                        <div className='d-flex align-items-end'>
                            {(!isFetchingDates && !error) && (
                                <p
                                    type='button'
                                    onClick={() => setShowDateAndTime(!showDateAndTime)}
                                    className='m-0 select-dateAndHour-btn-edit'
                                >
                                    {t('EDIT')}
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
            {showDateAndTime && (
                <DateAndTimeFormModal
                    isAccess={isAccess}
                    showModal={showDateAndTime}
                    setShowModal={() => setShowDateAndTime(!showDateAndTime)}
                    initialStateDates={date}
                    addDates={setDate}
                />
            )}
        </>
    )
}
export default SelectDateAndTime